/* eslint-disable import/no-unresolved */
import React, { Component } from "react";
import { selectors, actions } from "reducers/checks";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import { shape, string, func, bool, arrayOf } from "prop-types";
import { Box } from "@ui-kit/components/index.es";
import ContextMenu from "pages/_components/ContextMenu";
import { receivedEcheqsStatusActions, echeqShape } from "util/checks";
import specialOptions, { receivedEcheqAction } from "pages/checks/Echeqs/EcheqActions/EcheqsActionMaker";
import Button from "pages/_components/Button";
import { selectors as accountsSelectors } from "reducers/accounts";
import { selectors as sessionSelectors } from "reducers/session";

const FORM_ID = "echeq";

const echeqsIcons = {
    negociate: "BankSend",
    "emit.cesion": "Endosar",
    deposit: "Deposit",
    "request.return": "ClipboardBack",
    "anulate-echeq": "Error",
    admit: "Check",
    repudiate: "Cancel",
};

class ReceivedContextMenu extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        echeq: shape(echeqShape).isRequired,
        isDesktop: bool.isRequired,
        environmentCuit: string.isRequired,
        serverSearchDate: string.isRequired,
        detailActions: bool,
        isSmallDesktop: bool,
        navbarMenu: bool,
        setState: func.isRequired,
        accounts: arrayOf(shape({})).isRequired,
        isRetailEnvironment: bool.isRequired,
        location: shape({
            pathname: string.isRequired,
        }).isRequired,
    };

    static defaultProps = {
        detailActions: false,
        isSmallDesktop: false,
        navbarMenu: false,
    };

    echeqActions = (status) => {
        const actionsEcheqs = receivedEcheqsStatusActions;
        const {
            echeq,
            environmentCuit,
            dispatch,
            isDesktop,
            serverSearchDate,
            setState,
            accounts,
            isRetailEnvironment,
            location,
        } = this.props;
        let contextMenuActions = [];

        if (!isDesktop) {
            contextMenuActions = [
                {
                    label: "echeq.request.moreInfo.download",
                    onClick: () => {
                        dispatch(actions.downloadEcheqMobileInfo("pdf", echeq));
                    },
                    icon: "Eye",
                },
            ];
        }

        contextMenuActions = [
            ...contextMenuActions,
            ...specialOptions(echeq, serverSearchDate, environmentCuit, (action, echeqInfo) =>
                receivedEcheqAction(
                    action,
                    echeqInfo,
                    dispatch,
                    (newState) => {
                        setState({ ...newState });
                    },
                    isDesktop,
                    accounts,
                    isRetailEnvironment,
                    location.pathname,
                ),
            ),
        ];

        if (actionsEcheqs[status]) {
            actionsEcheqs[status].forEach((action) => {
                contextMenuActions = [
                    ...contextMenuActions,
                    {
                        label: `${FORM_ID}.${action.toLowerCase()}.echeq`,
                        onClick: () => {
                            receivedEcheqAction(
                                action,
                                echeq,
                                dispatch,
                                (newState) => setState({ ...newState }),
                                isDesktop,
                                accounts,
                                isRetailEnvironment,
                                location.pathname,
                            );
                        },
                        icon: echeqsIcons[action.toLowerCase()],
                    },
                ];
            });
        }

        return contextMenuActions;
    };

    render() {
        const { echeq, isDesktop, detailActions, isSmallDesktop, navbarMenu } = this.props;

        if (!echeq) {
            return null;
        }

        const itemsContextMenu = this.echeqActions(echeq.estado);
        let filteredEcheqActions;
        let depositOrCustodyButton;
        let discountButton;
        if (itemsContextMenu.length > 0) {
            depositOrCustodyButton = itemsContextMenu.find(
                (item) => item.label === "echeq.deposit.echeq" || item.label === "echeq.custody.echeq",
            );
            discountButton = itemsContextMenu.find((item) => item.label === "echeq.negotiate.echeq");
            filteredEcheqActions = itemsContextMenu.filter(
                (item) => item.label !== depositOrCustodyButton?.label && item.label !== discountButton?.label,
            );
        }

        let maxButtonsActions;
        if (depositOrCustodyButton && discountButton) {
            maxButtonsActions = isSmallDesktop ? 0 : 2;
        } else if (depositOrCustodyButton || discountButton) {
            maxButtonsActions = isSmallDesktop ? 0 : 2;
        } else {
            maxButtonsActions = isSmallDesktop ? 2 : 4;
        }

        return (
            <Box flex gap={16}>
                {detailActions && depositOrCustodyButton && (
                    <Button
                        className="btn-outline cmf-button-width"
                        block
                        label={depositOrCustodyButton.label}
                        onClick={depositOrCustodyButton.onClick}
                    />
                )}
                {detailActions && discountButton && (
                    <Button
                        className="btn-outline cmf-button-width"
                        block
                        label={discountButton.label}
                        onClick={discountButton.onClick}
                    />
                )}
                {detailActions &&
                    filteredEcheqActions &&
                    filteredEcheqActions.length <= maxButtonsActions &&
                    filteredEcheqActions?.map((item) => (
                        <Button
                            className="btn-outline cmf-button-width"
                            block
                            label={item.label}
                            key={item.label}
                            onClick={item.onClick}
                        />
                    ))}
                {detailActions && filteredEcheqActions?.length > maxButtonsActions && (
                    <ContextMenu isDesktop={isDesktop} items={filteredEcheqActions} />
                )}
                {!detailActions && itemsContextMenu.length > 0 && (
                    <ContextMenu
                        isDesktop={isDesktop}
                        items={itemsContextMenu}
                        color={navbarMenu && !isDesktop ? "white" : undefined}
                    />
                )}
            </Box>
        );
    }
}

const mapStateToProps = (state) => ({
    echeqsList: selectors.getEcheqsList(state),
    environmentCuit: selectors.getEnvironmentCuit(state),
    serverSearchDate: selectors.getServerSearchDate(state),
    accounts: accountsSelectors.getAccounts(state),
    isRetailEnvironment: sessionSelectors.isRetailEnvironment(state),
});

export default compose(withRouter, connect(mapStateToProps))(ReceivedContextMenu);
